import { NotificationView } from './notification.view';
import { useNotification } from './use-notification';

export function NotificationPage() {
  const logic = useNotification();
  return <NotificationView {...logic} />;
}
